import React, { useEffect } from 'react';
import Footer from '../../components/footer';
import { If, When, Choose, Otherwise } from 'babel-plugin-jsx-control-statements';
import { DEVICES, DeviceHelper, Pulse, NavigationHelpers } from 'common-utilities';
import PrimaryButton from '../../components/primaryButton';
import { useDeviceType } from 'common-utilities';
import { EVENT_CATEGORY, REDIRECT_URL, PAYTM_URL } from '../../constants';
import PaytmLogo from '../../assets/paytmSheild.svg';
import './style.scss';
import FooterLines from '../../components/footerLines';

function Success({ state }) {
	const DEVICE = useDeviceType();
	const userDetails = JSON.parse(sessionStorage && sessionStorage.getItem('state'));
	const redirectPaytmDeepLink =
		sessionStorage && sessionStorage.getItem('REDIRECT_PAYTM_DEEPLINK');
	useEffect(() => {
		setTimeout(() => {
			Pulse.push({
				event_action: 'unblock_otp_success',
				event_category: EVENT_CATEGORY,
				screenName: '/unblock_otp_success'
			});
		});
	}, []);
	return (
		<React.Fragment>
			<div className="successPageContainer">
				<div className="imageContainer">
					<img src={PaytmLogo} alt="paytm-icon" />
				</div>
				<div className="heading">OTP Unblocked Successfully</div>
				<div className="text-container">
					We have successfully restarted OTP service for your mobile number:{' '}
					{userDetails.moblieNumber}. Continue using Paytm App for exciting offers and
					services.
				</div>
				<Choose>
					<When condition={DEVICE === DEVICES.DESKTOP}>
						<div className="buttonContainer">
							<PrimaryButton
								onClick={() => {
									Pulse.push({
										event_action: 'goto_paytm_clicked',
										event_category: EVENT_CATEGORY,
										screenName: '/unblock_otp_success'
									});
									NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
								}}
								oauth-id="goto_paytm_btn"
							>
								Go to Paytm
							</PrimaryButton>
						</div>
					</When>
					<Otherwise>
						<div className="mobileButtonContainer">
							<button
								className="button primary"
								onClick={() => {
									Pulse.push({
										event_action: 'goto_paytm_clicked',
										event_category: EVENT_CATEGORY,
										screenName: '/unblock_otp_success'
									});
									NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
								}}
								oauth-id="goto_paytm_btn"
							>
								Go to Paytm App
							</button>
						</div>
					</Otherwise>
				</Choose>
			</div>
			{DEVICE === DEVICES.DESKTOP ? <Footer /> : <FooterLines />}
		</React.Fragment>
	);
}
export default Success;
